module.exports = __webpack_public_path__ + "static/media/FacistBoard_large_4.740470d1.png";